import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect, useMemo } from 'react';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.modalidades;
export default function Modalidade() {
  const { state, dispatch, validator, loadModalidades } =
    useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'modalidades',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  useEffect(() => {
    loadModalidades();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = useMemo(() => {
    return state.options.modalidades.options
      ? getOptionsFromParams(
          state.options.modalidades.options,
          'idModalidade',
          'nome'
        )
      : [];
  }, [state.options.modalidades.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          label={language.label}
          placeholder={language.placeholder}
          loading={state.options.modalidades.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.modalidades || []}
          multiple
          onChange={(option: { value: number; label: string }[]) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                modalidades: option ? option.map((m) => m.value) : [],
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
